export default "__VITE_ASSET__wn5_yiLr__"